import { Component } from '@angular/core';
import { RokezzzNotificationService } from '../../../notification/services/notification.service';
import { MatIconModule } from '@angular/material/icon';
import { Notification } from '../../api/notification';
import { NotificationType } from '../../api/notification-type';

@Component({
    selector: '.rokezzz-notification',
    standalone: true,
    imports: [
        MatIconModule
    ],
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
})

export class RokezzzNotificationComponent {
    public notifications: Notification[] = [];

    public constructor(
        private readonly rokezzzNotificationService: RokezzzNotificationService
    ) {
        this.notifications = this.rokezzzNotificationService.getNotifications();
    }

    public closeNotification(notification: Notification): void {
        this.rokezzzNotificationService.dismissNotification(notification);
    }

    public getNotificationIcon(notification: Notification): string {
        switch (notification.type) {
        case NotificationType.success:
            return 'check_circle';
        case NotificationType.error:
            return 'error';
        case NotificationType.warning:
            return 'warning';
        default:
            return 'info';
        }
    }
}
